import { StickerCard } from "@/components/sticker-card/StickerCard.tsx";
import { JobEditStep } from "@/pages/recruit/jobs/edit/job-edit.types.ts";
import { ApiJob, JobStatusItems } from "@/types/recruit/job.types.ts";
import { getJobProfileTitle } from "@/types/job-profile.types.ts";
import { Button, ButtonLink, FullScreenPage, Stack, Text, Title } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

interface JobEditFinalProps {
  jobSaved?: ApiJob;
  onClose: () => void;
}

export const JobEditFinal = ({ jobSaved, onClose }: JobEditFinalProps) => {
  const { t } = useTranslation();

  return (
    <FullScreenPage isCenterVertical={true} contentSize={"md"}>
      <Stack direction={"horizontal"} items={"center"}>
        <StickerCard
          title={jobSaved?.title}
          emoji={jobSaved?.emoji || undefined}
          status={JobStatusItems().find((status) => status.id === jobSaved?.status)?.title}
          contentSlot={
            <>{jobSaved?.job_profile && <Text>{getJobProfileTitle(jobSaved.job_profile)}</Text>}</>
          }
        />

        <Stack className={"pl-18"} gap={"lg"}>
          <Title size={"lg"} header={t("ats:job_saved")}></Title>

          <Stack direction={"horizontal"} gap={"sm"}>
            <Button onClick={onClose} size={"lg"}>
              {t("common:close")}
            </Button>
            <ButtonLink
              variant="secondary"
              size={"lg"}
              href={`/recruitment/jobs/${jobSaved?.id}/edit/${JobEditStep.details}`}
            >
              {t("common:edit")}
            </ButtonLink>
          </Stack>
        </Stack>
      </Stack>
    </FullScreenPage>
  );
};
